var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Music") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H6C5.45 0 5 0.45 5 1V9.35C4.54 9.13 4.04 9 3.5 9C1.57 9 0 10.57 0 12.5C0 14.43 1.57 16 3.5 16C5.43 16 7 14.43 7 12.5V6.02H14V9.35C13.54 9.13 13.04 9 12.5 9C10.57 9 9 10.57 9 12.5C9 14.43 10.57 16 12.5 16C14.43 16 16 14.43 16 12.5V1C16 0.45 15.55 0 15 0ZM3.5 14C2.67 14 2 13.33 2 12.5C2 11.67 2.67 11 3.5 11C4.33 11 5 11.67 5 12.5C5 13.33 4.33 14 3.5 14ZM7 4.02V2H14V4.02H7ZM12.5 14C11.67 14 11 13.33 11 12.5C11 11.67 11.67 11 12.5 11C13.33 11 14 11.67 14 12.5C14 13.33 13.33 14 12.5 14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/Music.6893fca37af03529bf2377866564aa1b.svg";
export { ForwardRef as ReactComponent };